<template>
    <section class="login-container">
        <FlagsComponent v-if="false"></FlagsComponent>

        <img v-if="retailGeneralParams?.URLLOGO" class="logo" :class="{ 'invisible-logo': !logo }" :src="retailGeneralParams.URLLOGO">
        <img v-else class="logo" :class="{ 'invisible-logo': !logo }" :src="retailGeneralParams?.TEMAESCURO ? require('@/assets/default/images/no-cash-dark.svg') : require('@/assets/default/images/no-cash.svg')">

        <section class="data-container">
            <div v-for="(element, elkey) in getLoginFormData" :key="elkey" class="elem-container" :class="{checkbox: element.type === 'checkbox'}">
                <template v-if="element.isVisible">
                    <label :for="getId(element.display)" v-text="element.display" :class="{required: element.required}"></label>
                    <select v-if="element.type === 'select'" :name="getId(element.display)" :id="getId(element.display)" v-model="element.value" @change="setBaseInfoOnStore(element.value)" class="default">
                        <option value=""></option>
                        <option v-for="(client, clientKey) in getBaseInfoList" :key="clientKey" :value="client" v-text="client.NMFANTCLIE"></option>
                    </select>
                    <template v-else>
                        <input :name="getId(element.display)" :id="getId(element.display)" :type="element.type" v-model.trim="element.value" :placeholder="element.placeHolder">
                    </template>
                </template>
            </div>
            <div v-for="(but, bKey) in getLoginButtons" :key="bKey" >
                <ButtonCenter
                    :button="but"
                    v-if="isVisibleButtons(but)"
                    @click="handleClick(but)">
                </ButtonCenter>
            </div>
        </section>
        <recover-password-component></recover-password-component>
        <ModalInfo></ModalInfo>
        <LoginStoreOptionsModal v-if="showLoginOptionsModal" @closeModal="showLoginOptionsModal = false" @closeAndEnter="login"></LoginStoreOptionsModal>
        <ScreenLoader :isLoading="loginIsLoading"></ScreenLoader>
        <span>{{ formatIfCnpj() }}</span>
    </section>
</template>

<script>
import { doLogin } from '@/components/controllers/LoginController.js'
import { startUp } from '@/components/controllers/StartUpController.js'
import FlagsComponent from '@/components/language/flags/FlagsComponent.vue'
import ButtonCenter from '@/components/buttons/center/ButtonCenter.vue'
import RecoverPasswordComponent from '@/components/bottom-popups/RecoverPasswordComponent.vue'
import ModalInfo from '@/components/modals/ModalInfo.vue'
import ScreenLoader from '@/components/loader/ScreenLoader.vue'
import LoginStoreOptionsModal from '@/components/modals/LoginStoreOptionsModal.vue'
import { mapGetters, mapActions } from 'vuex'
import { getLocalVar, hasWppParam, callWppHelp } from '@/libs/Util'
import { getEnv } from '@/libs/Environment.js'

export default {
    name: 'LoginView',
    components: {
        FlagsComponent,
        ButtonCenter,
        RecoverPasswordComponent,
        ModalInfo,
        LoginStoreOptionsModal,
        ScreenLoader
    },
    data () {
        return {
            logo: require('@/assets/default/images/logo.png'),
            showLoginOptionsModal: false
        }
    },
    computed: {
        ...mapGetters(['getLoginFormData', 'getLoginButtons', 'loginControlsEnabled', 'getBaseInfoList',
            'getLoginStoreOptions', 'loginIsLoading', 'retailGeneralParams', 'getPermissions'])
    },
    mounted () {
        this.setLoginControlsEnabled(true)
        const storedUser = getLocalVar('storedUser')
        if (storedUser?.shouldRememberPassword) {
            this.getLoginFormData[1].value = storedUser.userName
            this.getLoginFormData[2].value = '%use@stored@pass%'
            this.getLoginFormData[3].value = storedUser.shouldRememberPassword
        } else {
            this.resetLoginState()
        }
    },
    methods: {
        ...mapActions(['showModalInfo', 'setLoginControlsEnabled', 'resetLoginState', 'changeRecoverPasswordMenuVisibility',
            'setBaseInfo', 'setDefaultPasswordWarning', 'setLoginStoreOptions', 'startLoadingLogin', 'stopLoadingLogin']),

        getId: function (display) {
            return display.replaceAll(' ', '').toLowerCase()
        },
        login: async function () {
            try {
                this.startLoadingLogin()
                const response = await doLogin()
                if (response === false) {
                    return
                }
                const { usa_instituicao_cliente_filial: useInstituicaoClienteFilial } = getEnv()
                if (useInstituicaoClienteFilial === 'S' && response?.data?.showSelectPopup) {
                    this.setLoginStoreOptions(response.data.options)
                    this.showLoginOptionsModal = true
                }

                startUp(true)

                if (useInstituicaoClienteFilial === 'S' && response?.data?.baseInfo) {
                    this.setBaseInfo(response.data.baseInfo)
                }

                if (response?.data?.DEFAULTPASSWORD) {
                    this.setDefaultPasswordWarning(response.data.DEFAULTPASSWORD)
                }

                this.$router.push('home')
            } catch (error) {
                await this.showModalInfo({ type: 'error', text: error.message, open: true })
            } finally {
                this.stopLoadingLogin()
            }
        },
        register: function () {
            this.$router.push('register')
        },
        help: function () {
            callWppHelp()
        },
        hasWppParam: function () {
            return hasWppParam()
        },
        handleClick: function (but) {
            if (but.action) {
                this[but.action]()
            }
        },
        setBaseInfoOnStore: function (data) {
            this.setBaseInfo(data)
        },
        isVisibleButtons (button) {
            switch (button.action) {
            case 'register':
                return button.show
            case 'help':
                return this.hasWppParam()
            default:
                return true
            }
        },
        formatIfCnpj () {
            const cnpj = this.getPermissions.CNPJEXIBICAO
            if (!cnpj) return ''

            const cleaned = cnpj.toString().replace(/\D/g, '')
            if (cleaned.length !== 14) return ''

            const formatted = cleaned.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5')
            return `CNPJ: ${formatted}`
        }
    }
}
</script>
<style lang="less" >
.login-container .modal-container {
    background-color: var(--backgroundColor);
    border: solid 1px white;
}
</style>
<style lang="less" scoped>
.login-container {
    color: var(--textColor);
    &:before {
        content: '';
        background-color: var(--backgroundColor);
        pointer-events: none;
        position: absolute;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        z-index: -1;
    }
    button {
        color: var(--buttonText);
        &.fill {
            background-color: var(--buttonBackground);
            color: var(--buttonText);
        }
        font-size: 2.5vh;
        padding: 2vh 1.5vh;
        margin-bottom: 1.5vh;
    }
    .logo {
        position: relative;
        display: block;
        margin: 2vh auto;
        width: 100%;
        height: 15vh;
        object-fit: contain;
    }
    .invisible-logo {
        visibility: hidden;
    }
    .data-container {
        .elem-container{
            margin-bottom: 2vh;
            &.checkbox {
                display: flex;
                flex-direction: row-reverse;
                flex-wrap: nowrap;
                align-content: center;
                justify-content: flex-end;
                align-items: stretch;
            }
            label {
                display: block;
                position: relative;
                margin-bottom: 1.5vh;
                font-size: 2.5vh;
                &.required:after{
                    content: '*';
                    color: red;
                    margin-left: 5px;
                }
            }
            input:not([type="checkbox"]) {
                width: calc(100% - 3vh);
                border-radius: 5px;
                padding: 2vh 1.5vh;
                background: #E2E2E2;
                border: none;
                font-size: 2.5vh;
            }

            input[type="checkbox"] {
                accent-color: var(--buttonBackground);
                position: relative;
                display: block;
                width: 4vh;
                height: 3.5vh;
                padding: 0;
                margin: 0 1vh 0 0;
            }
        }
    }
    span {
        display: flex;
        justify-content: center;
        font-weight: 600;
        font-size: 2.5vh;
        padding: 1vh;
    }
}
</style>
